export default {
  // 主题色相关色号
  '--theme-color-primary': '#006AFF',
  '--theme-color-hover': '#4D9AFF',
  '--theme-color-active': '#0055CC',
  '--theme-color-disable': '#CAE2FF',
  // 文字类相关色号
  '--theme-text-primary': '#1E2226',
  '--theme-text-hover': '#006AFF',
  '--theme-text-secondary': '#494E56',
  '--theme-text-subsidiary': '#7A8088',
  '--theme-text-disable': '#C4C7CC',
  '--theme-text-link': '#006AFF',
  '--theme-light': '#FFFFFF',
  '--theme-dark': '#000000',
  // 背景类相关色号
  '--theme-bg-white': '#FFFFFF',
  '--theme-bg-gray': '#F5F7FA',
  '--theme-bg-hover': '#F2F8FF',
  '--theme-bg-active': '#E5F1FF',
  '--theme-bg-dark': '#000000',
  // border类相关色号
  '--theme-border-color': '#DADCE0',
  // 分割线相关色号
  '--theme-divider-horizontal': '#F5F7FA',
  '--theme-divider-vertical': '#EBEDF0',
  // 反馈类相关色号
  '--theme-primary-border': '#96C4FF',
  '--theme-success': '#00C261',
  '--theme-success-bg': '#DEF7EA',
  '--theme-success-border': '#88E5B5',
  '--theme-warning': '#FF7700',
  '--theme-warning-bg': '#FFF0E5',
  '--theme-warning-border': '#FFC698',
  '--theme-error': '#FF2626',
  '--theme-error-bg': '#FFE5E6',
  '--theme-error-border': '#FFA3A5',

  // border-radius
  '--theme-border-radius-tiny': '2px',
  '--theme-border-radius-small': '4px',
  '--theme-border-radius-normal': '6px',
  '--theme-border-radius-big': '8px',
  '--theme-border-radius-large': '10px',

  // space
  '--theme-page-space': '16px', // 页面内间距
  '--theme-block-margin': '12px', // 页面容器、元素之间间距
  '--theme-block-padding': '20px', // 容器内间距

  // font
  '--theme-font-small': '12px',
  '--theme-font-normal': '14px',
  '--theme-font-large': '16px',
  '--theme-font-18': '18px',
  '--theme-font-20': '20px',
  '--theme-font-22': '22px',
  '--theme-font-24': '24px',
  '--theme-font-26': '26px',
  '--theme-font-28': '28px',
  '--theme-font-32': '32px',
  '--theme-font-36': '36px',
  '--theme-font-41': '41px',

  // font-weight
  '--theme-font-weight-semibold': '600',
  '--theme-font-weight-regular': '400',
};
